import { StatusBar } from "expo-status-bar";
import React from "react";
import { DefaultTheme, Provider as PaperProvider } from "react-native-paper";
import { Provider as ReduxProvider } from "react-redux";
import { Play } from "./components/Play";
import { SoundContext } from "./contexts/sound";
import { useSound } from "./hooks/useSound";
import { store } from "./redux";

export const App: React.FC = () => {
  return (
    <SoundContext.Provider value={useSound()}>
      <PaperProvider theme={DefaultTheme}>
        <ReduxProvider store={store}>
          <StatusBar hidden />
          <Play />
        </ReduxProvider>
      </PaperProvider>
    </SoundContext.Provider>
  );
};

export default App;
